import axios from 'axios';
// Create an Axios instance
const service = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});
// Add a request interceptor to include the token in headers
service.interceptors.request.use(async (config) => {
    return config;
}, (error) => {
    return Promise.reject(error);
});
export default service;
